import React, { useEffect, useRef } from "react";
import { FaChevronDown } from "react-icons/fa";
import Button from "./Button";

function Popover({
  children,
  label = "Select Option",
  disabled = false,
  openPosition = "bottom",
  className = "",
  onSelect,
  showChevron = true,
  width = "400px",
  isOpen = false, // Changed to controlled prop
  onOpenChange, // Required callback for handling open state
}) {
  const dropdownRef = useRef(null);

  // Toggle the dropdown open/close state
  const toggleDropdown = () => {
    if (onOpenChange) {
      onOpenChange(!isOpen);
    }
  };

  // Handle clicks outside the popover
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onOpenChange(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onOpenChange]);

  const positionClasses = openPosition === "top" 
    ? "absolute left-0 bottom-full mb-2" 
    : "absolute left-0 top-full mt-2";

  return (
    <div className={`relative inline-block w-fit ${className}`} ref={dropdownRef}>
      <Button
        disabled={disabled}
        type="link"
        onClick={toggleDropdown}
        className="w-full flex justify-between items-center"
      >
        {label}
        {showChevron && (
          <FaChevronDown 
            className={`ml-2 transition-transform duration-200 ${
              isOpen ? "rotate-180" : ""
            }`} 
          />
        )}
      </Button>

      {isOpen && (
        <div
          className={`${positionClasses} bg-white border border-gray-300 rounded-lg shadow-lg z-10`}
          style={{ width }}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default Popover;